import { render, staticRenderFns } from "./ItemText.vue?vue&type=template&id=254ef28c&scoped=true&"
import script from "./ItemText.vue?vue&type=script&lang=js&"
export * from "./ItemText.vue?vue&type=script&lang=js&"
import style0 from "./ItemText.vue?vue&type=style&index=0&id=254ef28c&prod&scoped=true&lang=css&"
import style1 from "./ItemText.vue?vue&type=style&index=1&id=254ef28c&prod&lang=css&"
import style2 from "./ItemText.vue?vue&type=style&index=2&id=254ef28c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ef28c",
  null
  
)

export default component.exports